/*
Stateless component to allow the passing of props to the route elements
*/
import React from 'react';
import { Route, Routes } from 'react-router-dom';
// import React from 'react'
// import { Route } from 'react-router-dom'

const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest)
  return React.createElement(component, finalProps)
}

// const PropsRoute = ({ component, ...rest }) => {
//   return (
//     <Route
//       {...rest}
//       render={routeProps => {
//         return renderMergedProps(component, routeProps, rest)
//       }}
//     />
//   )
// }
// export default PropsRoute;



const PropsRoute = ({ element, ...rest }) => {
  return (
    <Routes>
      <Route {...rest} element={element} />
    </Routes>
  )
};

export default PropsRoute
